/**
 * Family Swatches v1
 * Click a .family-swatch on a collection card → fetch the target product's
 * card via the family-card-ajax section and swap it in. No reload.
 *
 * Styles are injected once per page (init guard prevents repeats).
 *
 * CONFIG below — adjust cardWrapperSelector if Blum's card outer element differs.
 */
(function () {
  if (window.__familySwatchesInit) return;
  window.__familySwatchesInit = true;

  // ---- Styles (injected once) ----
  var css = `
  .card__content-vendor {display:none;}
    .family-swatches--card,
    .family-swatches--page { display: flex; flex-wrap: wrap; align-items: center; line-height: 1; }
    .family-swatches--page { gap: 8px; margin: 0 0 1rem; }
    .family-swatches--card { gap: 5px; margin: 4px 0 12px; padding-right: 8px; }
    .family-swatches__heading { font-size: 0.9rem; margin: 1rem 0 0.4rem; font-weight: 600; }
    .family-swatches--card .family-swatch,
    .family-swatches--page .family-swatch {
      display: inline-block;
      width: 28px; height: 28px;
      padding: 0;
      border: 1px solid rgba(0,0,0,0.15);
      border-radius: 50%;
      cursor: pointer;
      background-clip: padding-box;
      transition: transform 0.15s ease;
    }
    .family-swatches--page .family-swatch { width: 28px; height: 28px; }
    .family-swatches--card .family-swatch:hover,
    .family-swatches--page .family-swatch:hover { transform: scale(1.1); }
    .family-swatches--card .family-swatch.is-active,
    .family-swatches--page .family-swatch.is-active { outline: 2px solid currentColor; outline-offset: 2px; }
    .family-card--swapping { opacity: 0.55; transition: opacity 0.2s ease; pointer-events: none; }
  `;
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ---- Config ----
  var CONFIG = {
    cardWrapperSelector: '.product-card',
    sectionId: 'family-card-ajax',
    swappingClass: 'family-card--swapping',
    reinitJudgeMe: false   // flip true if review stars don't show after swap
  };

  // ---- Click handler ----
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-family-swatch]');
    if (!swatch || swatch.classList.contains('is-active')) return;
    e.preventDefault();
    swapCard(swatch);
  });

  function swapCard(swatch) {
    var card = swatch.closest(CONFIG.cardWrapperSelector);
    if (!card) {
      console.warn('[family-swatches] Card wrapper not found — adjust cardWrapperSelector.');
      window.location.href = swatch.dataset.url;
      return;
    }

    card.classList.add(CONFIG.swappingClass);
    var url = '/products/' + swatch.dataset.handle + '?section_id=' + CONFIG.sectionId;

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCard = doc.querySelector(CONFIG.cardWrapperSelector);
        if (!newCard) throw new Error('No card in response');
        card.replaceWith(newCard);
        if (CONFIG.reinitJudgeMe && window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
          window.jdgm.customizeBadges();
        }
      })
      .catch(function (err) {
        console.error('[family-swatches]', err);
        card.classList.remove(CONFIG.swappingClass);
        window.location.href = swatch.dataset.url;
      });
  }
})();